import {
    GETENTITYTYPELISTABLE_SUCCESS,
    GETENTITYTYPELISTABLE_FAILED,
    RESET_GETENTITYTYPELISTABLE,
    LOADING_GETENTITYTYPELISTABLE,
    NETWORK_ERROR_GETENTITYTYPELISTABLE,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetEntityTypeListTable = () => {
    return { type: RESET_GETENTITYTYPELISTABLE };
};

const getEntityTypeListTable = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETENTITYTYPELISTABLE });
    await adminServices
        .post("getEntityTypeListTable", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getEntityTypeListTablesuccess(res.data));
                    break;
                default:
                    dispatch(getEntityTypeListTableFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETENTITYTYPELISTABLE, payload: err });
        });
};
function getEntityTypeListTablesuccess(data) {
    return {
        type: GETENTITYTYPELISTABLE_SUCCESS,
        payload: data,
    };
}
function getEntityTypeListTableFailed(data) {
    return {
        type: GETENTITYTYPELISTABLE_FAILED,
        payload: data,
    };
}

export { resetGetEntityTypeListTable, getEntityTypeListTable };
